import { render, staticRenderFns } from "./risk-maintenance-id-cell.vue?vue&type=template&id=5b9d8c55&scoped=true"
import script from "./risk-maintenance-id-cell.vue?vue&type=script&lang=ts"
export * from "./risk-maintenance-id-cell.vue?vue&type=script&lang=ts"
import style0 from "./risk-maintenance-id-cell.vue?vue&type=style&index=0&id=5b9d8c55&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9d8c55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b9d8c55')) {
      api.createRecord('5b9d8c55', component.options)
    } else {
      api.reload('5b9d8c55', component.options)
    }
    module.hot.accept("./risk-maintenance-id-cell.vue?vue&type=template&id=5b9d8c55&scoped=true", function () {
      api.rerender('5b9d8c55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/budget-requests/accordion-budget-requests/cells/risk-maintenance-id-cell.vue"
export default component.exports